import { Token } from '@akropolis-web/primitives';
import React from 'react';

import { styled } from 'core/styles';

import { TokenIcon, TokenIconProps } from '../TokenIcon';

export function TokenName({
  token,
  iconSize = 'inherit',
  symbol,
  maxWidth,
}: {
  token: Token;
  iconSize?: TokenIconProps['fontSize'];
  symbol?: React.ReactNode;
  maxWidth?: number;
}) {
  return (
    <Root>
      <TokenIconContainer>
        <TokenIcon token={token} fontSize={iconSize} />
      </TokenIconContainer>
      <TokenSymbol maxWidth={maxWidth}>{symbol || token.symbol}</TokenSymbol>
    </Root>
  );
}

const Root = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '1em',
}));

const TokenIconContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  fontSize: 15,
  marginRight: 5.5,
  marginTop: -1,

  [theme.breakpoints.up('tabletXS')]: {
    fontSize: 24,
    marginRight: 10,
  },
}));

const TokenSymbol = styled('div', { shouldForwardProp: prop => prop !== 'maxWidth' })<{
  maxWidth: number | undefined;
}>(({ maxWidth }) => ({
  maxWidth: maxWidth || 120,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
